// skipcq: JS-W1028
import { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PropTypes from 'prop-types';

const TAB_PROFILE = 'profile';
const TAB_REVIEWS = 'reviews';

function PintPortfolioBeerWorkspaceTabs({
  profileContent,
  reviewsContent,
  summaryContent,
  onTabChange,
}) {
  const [activeTab, setActiveTab] = useState(TAB_PROFILE);

  const handleTabChange = useCallback(
    (_event, nextTab) => {
      setActiveTab(nextTab);
      if (typeof onTabChange === 'function') {
        onTabChange(nextTab);
      }
    },
    [onTabChange],
  );

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label="Beer workspace tabs"
      >
        <Tab
          value={TAB_PROFILE}
          label="Profile"
          id="pint-portfolio-tab-profile"
          aria-controls="pint-portfolio-tabpanel-profile"
        />
        <Tab
          value={TAB_REVIEWS}
          label="Reviews"
          id="pint-portfolio-tab-reviews"
          aria-controls="pint-portfolio-tabpanel-reviews"
        />
      </Tabs>
      {summaryContent ? (
        <Box sx={{ mt: 2 }}>{summaryContent}</Box>
      ) : null}
      <Box
        role="tabpanel"
        hidden={activeTab !== TAB_PROFILE}
        id="pint-portfolio-tabpanel-profile"
        aria-labelledby="pint-portfolio-tab-profile"
        sx={{ pt: 2 }}
      >
        {activeTab === TAB_PROFILE ? profileContent : null}
      </Box>
      <Box
        role="tabpanel"
        hidden={activeTab !== TAB_REVIEWS}
        id="pint-portfolio-tabpanel-reviews"
        aria-labelledby="pint-portfolio-tab-reviews"
        sx={{ pt: 2 }}
      >
        {activeTab === TAB_REVIEWS ? reviewsContent : null}
      </Box>
    </>
  );
}

PintPortfolioBeerWorkspaceTabs.propTypes = {
  profileContent: PropTypes.node.isRequired,
  reviewsContent: PropTypes.node.isRequired,
  summaryContent: PropTypes.node,
  onTabChange: PropTypes.func,
};

export default PintPortfolioBeerWorkspaceTabs;
export { TAB_PROFILE, TAB_REVIEWS };
